import { lazy } from "react";
import type { FeatureRoute } from "./route-types";
import { routes as team } from "../features/team/routes";
import { routes as hr } from "../features/hr/routes";
import { routes as documents } from "../features/documents/routes";
import { routes as work } from "../features/work/routes";
import { routes as comms } from "../features/comms/routes";
import { routes as money } from "../features/money/routes";
import { routes as settings } from "../features/settings/routes";

/**
 * Özellik rotaları. Her alan kendi `routes.ts` dosyasında rotalarını tanımlar ve sayfalarını tembel
 * yükler (ilk açılış hızlı kalır). Yeni alan eklerken yalnızca buraya bir satır eklenir.
 */
const core: FeatureRoute[] = [
  { path: "izin", Component: lazy(() => import("../features/leave/LeavePage")) },
  { path: "izin/yeni", Component: lazy(() => import("../features/leave/NewLeavePage")) },
  { path: "izin/talepler/:id", Component: lazy(() => import("../features/leave/LeaveRequestPage")) },
  { path: "izin/kayit/:year", Component: lazy(() => import("../features/leave/LeaveRecordPage")) },
  { path: "onaylar", Component: lazy(() => import("../features/approvals/ApprovalsPage")) },
  { path: "profil", Component: lazy(() => import("../features/profile/ProfilePage")) },
];

export const routes: FeatureRoute[] = [...core, ...team, ...hr, ...documents, ...work, ...comms, ...money, ...settings];
